import React from 'react'
import { get } from 'lodash'
import { Table, Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faPlay } from '@fortawesome/free-solid-svg-icons'
import Card from 'src/components/Card'
import { useReportBuilder } from 'src/queries/cat/reporting/useReportBuilder'
import { useReportBuilderContext } from '../ReportBuilderContext'
import { exportToCsv } from '../helpers'

const ResultsTable: React.FC = () => {
  const { mongoQuery, selectedFields, runQuery } = useReportBuilderContext()
  const data = useReportBuilder(mongoQuery)
  const results = data?.results ?? []

  const handleExport = (): void => {
    exportToCsv(results, selectedFields)
  }

  return (
    <Card
      title='Results'
      primaryAction={{ key: 'export', icon: faDownload, text: 'Export CSV', onClick: handleExport, disabled: results.length === 0 }}
    >
      <Table striped responsive>
        <thead>
          <tr>
            {selectedFields.map((field) => (
              <th key={field.name}>{field.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {mongoQuery === undefined
            ? (
              <tr>
                <td colSpan={selectedFields.length} className='text-center py-5'>
                  <Button color='primary' size='lg' onClick={runQuery}>
                    <FontAwesomeIcon icon={faPlay} className='me-2' />
                    Run Query
                  </Button>
                </td>
              </tr>
              )
            : results.map((row, i) => (
              <tr key={i}>
                {selectedFields.map((field) => (
                  <td key={field.name}>
                    {(field.render != null) ? field.render(field.name, get(row, field.name), row) : get(row, field.name)}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </Table>
    </Card>
  )
}

export default ResultsTable
